const initialState = {
  userQueryProjectList: null,
  userQueryProjectDetail: null,

  loading: false,
  listLoading: false,

  error: null,

  userQueryProjectAdded: false,
  userQueryProjectUpdated: false,
  userQueryProjectDeleted: false,
};

export const userQueryProjectReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LIST_USER_QUERY_PROJECT_REQUEST":
      return {
        ...state,
        listLoading: true,
        error: null,
      };

    case "ADD_USER_QUERY_PROJECT_REQUEST":
    case "UPDATE_USER_QUERY_PROJECT_REQUEST":
    case "VIEW_USER_QUERY_PROJECT_REQUEST":
    case "DELETE_USER_QUERY_PROJECT_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "LIST_USER_QUERY_PROJECT_SUCCESS":
      return {
        ...state,
        listLoading: false,
        userQueryProjectList: action.payload,
        error: null,
      };

    case "LIST_USER_QUERY_PROJECT_FAILED":
      return {
        ...state,
        listLoading: false,
        error: action.payload,
      };

    case "ADD_USER_QUERY_PROJECT_SUCCESS":
      return {
        ...state,
        loading: false,
        userQueryProjectAdded: true,
        error: null,
      };

    case "ADD_USER_QUERY_PROJECT_FAILED":
      return {
        ...state,
        loading: false,
        userQueryProjectAdded: false,
        error: action.payload,
      };

    case "UPDATE_USER_QUERY_PROJECT_SUCCESS":
      return {
        ...state,
        loading: false,
        userQueryProjectDetail: action.payload,
        userQueryProjectUpdated: true,
        error: null,
      };

    case "UPDATE_USER_QUERY_PROJECT_FAILED":
      return {
        ...state,
        loading: false,
        userQueryProjectUpdated: false,
        error: action.payload,
      };

    case "VIEW_USER_QUERY_PROJECT_SUCCESS":
      return {
        ...state,
        loading: false,
        userQueryProjectDetail: action.payload,
        error: null,
      };

    case "VIEW_USER_QUERY_PROJECT_FAILED":
      return {
        ...state,
        loading: false,
        userQueryProjectDetail: null,
        error: action.payload,
      };

    case "DELETE_USER_QUERY_PROJECT_SUCCESS":
      return {
        ...state,
        loading: false,
        userQueryProjectDeleted: true,
        error: null,
      };

    case "DELETE_USER_QUERY_PROJECT_FAILED":
      return {
        ...state,
        loading: false,
        userQueryProjectDeleted: false,
        error: action.payload,
      };

    case "CLEAR_USER_QUERY_PROJECT_FLAGS":
      return {
        ...state,
        userQueryProjectAdded: false,
        userQueryProjectUpdated: false,
        userQueryProjectDeleted: false,
        error: null,
      };

    case "STOP_LOADING":
      return {
        ...state,
        loading: false,
        listLoading: false,
      };

    default:
      return state;
  }
};